import {Logo} from "../../../../assets/svgs/Sidebar";

export default function NoSidebar() {
  return <div className='px-[41px] py-[48px] h-[145px] w-[224px] fixed top-0 left-0'>
    <Logo isDynamic={false}/>
  </div>
}